import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep2_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F43.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame43() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);


        return (
            <div className="F43_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F43_entryBox">
                    <div className="F43_paragraph">
                        {language === 'english' ?
                            <p className="F43_paragraphEnglish">During the conversation with her teacher, and she was fearing, Saira realizes that her pad has leaked. </p>
                            :
                            <p className="F43_paragraphUrdu">اسی گفتگو کے دوران اچانک سائرہ کا پیڈ لیک ہو جاتا ہے۔</p>
                        }
                    </div>

                    <div className="F43_timeline">
                        <div className='F43_timelineBar'>
                            <div className='F43_timelineFill'></div>
                            <span className='F43_timelineText'>15/19</span>
                        </div>
                    </div>

                    <div className="F43_nextFrames">
                        <div className="F43_nextFrame1"></div>
                        <div className="F43_nextFrame2"></div>
                        <div className="F43_nextFrame3"></div>
                    </div>

                    <div className='F43_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep2_lastVisitFrame(15)) }} className='F43_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
}

export default Frame43;